import { useWishlist } from "@/store";

/**
 * Сердечко идеи: сохранена ли она и переключатель (общий для стены, страницы
 * идеи и кнопки «В избранное»).
 *
 * Шлюз хранит и отдаёт лайки идей ключом `slug || id` (`ideaLikeId` в
 * store/wishlist; так же лайкает мобилка), а витрина лайкала и сверяла по
 * `FeedCollection.id` (`col_<slug>`), и после сверки с сервером сердечко
 * гасло (причина A-27). `likeId` — этот ключ, им ставим новый лайк;
 * `altId` — id ленты: локальный лайк, поставленный до исправления, тоже
 * считается, а снимаем ровно по той ссылке, что лежит в списке (шлюз
 * принимает обе).
 */
export const useIdeaSaved = (likeId: string, altId?: string) => {
	const key = useWishlist((s) =>
		s.ideaIds.includes(likeId) ? likeId : altId && s.ideaIds.includes(altId) ? altId : null,
	);
	const toggleIdea = useWishlist((s) => s.toggleIdea);
	const setIdeaLikedOnServer = useWishlist((s) => s.setIdeaLikedOnServer);
	const toggle = () => {
		const ref = key ?? likeId;
		const liked = toggleIdea(ref);
		void setIdeaLikedOnServer(ref, liked);
	};
	return { saved: key != null, toggle };
};
